import { Weapon, WeaponType } from './Weapon';
import { CannonWeapon } from './CannonWeapon';
import { MachineGunWeapon } from './MachineGunWeapon';
import { MissileWeapon } from './MissileWeapon';
import { MineWeapon } from './MineWeapon';

export class WeaponManager {
  private weapons: Map<WeaponType, Weapon>;
  private currentWeaponType: WeaponType;

  constructor() {
    this.weapons = new Map();

    // Initialize all weapons
    this.weapons.set('cannon', new CannonWeapon());
    this.weapons.set('machinegun', new MachineGunWeapon());
    this.weapons.set('missile', new MissileWeapon());
    this.weapons.set('mine', new MineWeapon());

    this.currentWeaponType = 'cannon';
  }

  update(deltaTime: number): void {
    // Update all weapons (for cooldown timers)
    this.weapons.forEach(weapon => weapon.update(deltaTime));
  }

  getCurrentWeapon(): Weapon {
    return this.weapons.get(this.currentWeaponType)!;
  }

  switchWeapon(type: WeaponType): boolean {
    if (!this.weapons.has(type)) return false;
    this.currentWeaponType = type;
    return true;
  }

  getWeapon(type: WeaponType): Weapon | undefined {
    return this.weapons.get(type);
  }

  getAllWeapons(): Weapon[] {
    return Array.from(this.weapons.values());
  }

  getCurrentWeaponType(): WeaponType {
    return this.currentWeaponType;
  }

  // Reload specific weapon
  reloadWeapon(type: WeaponType, amount: number): void {
    const weapon = this.weapons.get(type);
    if (weapon) {
      weapon.reload(amount);
    }
  }

  // Reload all weapons
  reloadAll(): void {
    this.weapons.forEach(weapon => {
      weapon.reload(weapon.config.maxAmmo);
    });
  }
}
